// extracted by mini-css-extract-plugin
export default {"wrapper_input":"styles_wrapper_input__iszsl","input":"styles_input__H0w6m","buttonDeleteSearch":"styles_buttonDeleteSearch__T66mf"};